import Image from "next/image";
import { Link } from "@/app/config/navigation";
import React from "react";
export type ContactIconPropsType = {
  className?: string;
};
function ContactIcon({ className }: ContactIconPropsType) {
  return (
    <Link href="/contact-us" aria-label="Contact us">
      {" "}
      <div
        className={` rounded-full mx-8 w-[5rem] h-[5rem] md:w-[4.3rem] md:h-[4.3rem] flex  items-center bg-white justify-center ${className}`}
      >
        {" "}
        <Image
          width={30}
          loading="eager"
          height={30}
          className="w-[3.7rem] h-[3.7rem] lg:w-[3.3rem] lg:h-[3.3rem]"
          src="/icons/message.svg"
          alt="message"
        />
      </div>
    </Link>
  );
}

export default ContactIcon;
